import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Button,
  Table,
  message,
  Spin,
  Card,
  Typography,
  Input,
} from "antd";
import { ReloadOutlined, CarOutlined } from "@ant-design/icons";
import { useTranslation } from "react-i18next";
import _ from "lodash";

const { Title } = Typography;
const { Search } = Input;

export const Axios = axios.create({
  baseURL: process.env.REACT_APP_APPI_ADDRESS,
});

const AuditoriaRuta = () => {
  if (sessionStorage.getItem("user_mod")) sessionStorage.removeItem("user_mod");

  const { t } = useTranslation();
  const [bottom] = useState("bottomCenter");
  const [original, setOriginal] = useState([]);
  const [data, setData] = useState([]);
  const [spinning, setSpinning] = useState(false);
  const [spinTitle, setSpinTitle] = useState(t("global.loading"));
  const [messageApi, contextHolder] = message.useMessage();
  const [loading] = useState(false);
  const [searchValue, setSearchValue] = useState("");

  const headers = {
    accept: "*/*",
    Authorization: "Bearer " + sessionStorage.getItem("token"),
    "Content-Type": "application/json",
  };

  useEffect(() => {
    recargar();
  }, []);

  const filterData = (data) => (formatter) =>
    data.map((item) => ({
      text: formatter(item),
      value: formatter(item),
    }));

  const columns = [
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("auditoria_ruta.col_matricula")}
        </p>
      ),
      dataIndex: "matricula",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.matricula),
        _.isEqual
      ),
      onFilter: (value, record) => record.matricula.startsWith(value),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("auditoria_ruta.col_tipo_vehiculo")}
        </p>
      ),
      dataIndex: "tipovehiculo",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.tipovehiculo),
        _.isEqual
      ),
      onFilter: (value, record) => record.tipovehiculo.startsWith(value),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("auditoria_ruta.col_chofer")}
        </p>
      ),
      dataIndex: "chofer",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.chofer),
        _.isEqual
      ),
      onFilter: (value, record) => record.chofer.startsWith(value),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("auditoria_ruta.col_cant_paquetes")}
        </p>
      ),
      dataIndex: "cantidadpaquetes",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.cantidadpaquetes),
        _.isEqual
      ),
      onFilter: (value, record) => record.cantidadpaquetes.startsWith(value),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("auditoria_ruta.col_tiempo_estimado")}
        </p>
      ),
      dataIndex: "tiempoestimado",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.tiempoestimado),
        _.isEqual
      ),
      onFilter: (value, record) => record.tiempoestimado.startsWith(value),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("auditoria_ruta.col_fechaeliminacion")}
        </p>
      ),
      dataIndex: "fechacancelada",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.fechacancelada),
        _.isEqual
      ),
      onFilter: (value, record) => record.fechacancelada.startsWith(value),
    },
    {
      title: (
        <p
          style={{
            margin: "0px 0",
            fontSize: "15px",
            fontWeight: "bold",
            color: "#2c3e50",
            fontFamily: "'Roboto', sans-serif",
            textShadow: "1px 1px 2px rgba(0,0,0,0.2)",
          }}
        >
          {t("auditoria_ruta.col_nombreusuario")}
        </p>
      ),
      dataIndex: "nombreusuario",
      width: 200,
      filterSearch: true,
      filters: _.uniqWith(
        filterData(data)((i) => i.nombreusuario),
        _.isEqual
      ),
      onFilter: (value, record) => record.nombreusuario.startsWith(value),
    },
  ];

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: data.length, // Asegúrate de tener el total de elementos aquí
  });

  const handleTableChange = (newPagination) => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    });
  };

  const recargar = () => {
    //limpiar la busqueda del componente Search
    setSearchValue("");

    setSpinTitle(t("global.loading"));
    setSpinning(true);
    let aux = [];

    // let start = 0;
    // let limit = 1000;

    Axios.post(
      "auditoria/getHistorialRuta",
      {
        // "start": start,
        // "limit": limit,
        // "filtro":{
        //     "idrol": 1
        // }
      },
      {
        headers: headers,
      }
    )
      .then((response) => {
        setSpinning(false);
        if (response.data.data.length > 0) {
          for (let i = 0; i < response.data.data.length; i++) {
            aux.push({
              key: response.data.data[i].idrutahistorial,
              idrutahistorial: response.data.data[i].idrutahistorial,
              idvehiculo: response.data.data[i].idvehiculo,
              matricula: response.data.data[i].matricula,
              cantidadpaquetes: response.data.data[i].cantidadpaquetes,
              distanciatotal: response.data.data[i].distanciatotal,
              tiempoestimado: response.data.data[i].tiempoestimado,
              fechacancelada: response.data.data[i].fechacancelada,
              tipovehiculo: response.data.data[i].tipovehiculo,
              chofer: response.data.data[i].chofer,
              nombreusuario: response.data.data[i].nombreusuario,
            });
          }
        }

        setData(aux);
        setOriginal(aux);
      })
      .catch(() => {
        setSpinning(false);
      });
  };

  const onSearch = (value) => {
    filterLocal(value);
  };

  const filterLocal = (value) => {
    if (value === "" || value === null) {
      setData(original);
    } else {
      let aux = [];
      original.forEach(function (option) {
        if (
          option.matricula.toUpperCase().indexOf(value.toUpperCase()) !== -1
        ) {
          aux.push(option);
        }
      });
      setData(aux);
    }
  };


  return (
    <div
      style={{
        minHeight: "100vh",
        background: "linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)",
        padding: "16px",
      }}
    >
      <Spin spinning={spinning} tip={spinTitle} size={"large"}>
        <div
          style={{
            maxWidth: "1400px",
            margin: "0 auto",
          }}
        >
          {/* Header Card */}
          <div style={{
            background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
            borderRadius: '8px',
            padding: '12px',
            marginBottom: '12px',
            color: 'white',
            boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '16px'
            }}>
              <div style={{
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '50%',
                width: '24px',
                height: '24px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '12px'
              }}>
                <CarOutlined />
              </div>
              <div style={{ flex: 1 }}>
                <Title level={4} style={{
                  color: 'white',
                  margin: 0,
                  fontSize: '16px'
                }}>
                  {t("auditoria_ruta.title")}
                </Title>
                <p style={{
                  color: 'rgba(255,255,255,0.8)',
                  margin: 0,
                  fontSize: '12px'
                }}>
                  Auditoría rutas • {data.length} registros
                </p>
              </div>
              <div style={{
                background: 'rgba(255,255,255,0.2)',
                borderRadius: '8px',
                padding: '8px 16px'
              }}>
                <p style={{ color: 'white', margin: 0, fontSize: '14px', fontWeight: 'bold' }}>
                  {data.length} registros
                </p>
              </div>
            </div>
          </div>

          {/* Toolbar Card */}
          <Card style={{
            borderRadius: '8px',
            marginBottom: '12px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: 'none'
          }} styles={{ body: { padding: '12px' } }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              gap: '8px',
              flexWrap: 'wrap'
            }}>
              <Search
                placeholder={t("auditoria_ruta.search")}
                style={{
                  width: 160,
                  height: '32px'
                }}
                size="small"
                onSearch={onSearch}
                value={searchValue}
                onChange={(e) => {
                  setSearchValue(e.target.value);
                  filterLocal(e.target.value);
                }}
              />
              <Button
                icon={<ReloadOutlined />}
                onClick={recargar}
                loading={loading}
                size="small"
                style={{
                  background: 'linear-gradient(135deg, #253289 0%, #4a5acf 100%)',
                  borderColor: '#253289',
                  color: 'white',
                  borderRadius: '8px',
                  height: '32px',
                  fontWeight: '500',
                  boxShadow: '0 2px 8px rgba(37, 50, 137, 0.3)'
                }}
              >
                {t("global.reload")}
              </Button>
            </div>
          </Card>

          {/* Table Card */}
          <Card style={{
            borderRadius: '8px',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            border: 'none'
          }} styles={{ body: { padding: '0' } }}>
            {contextHolder}
            <Table
              size="small"
              scroll={{ y: 500 }}
              bordered={false}
              pagination={{
                position: [bottom],
                current: pagination.current,
                pageSize: pagination.pageSize,
                showSizeChanger: true,
                pageSizeOptions: ["10", "20", "50", "100"],
                showTotal: (total) => (
                  <span
                    style={{
                      color: "#253289",
                      fontWeight: "500",
                    }}
                  >
                    Total {total} elementos
                  </span>
                ),
                style: {
                  padding: "8px 12px",
                },
              }}
              onChange={handleTableChange}
              columns={columns}
              dataSource={data}
              onRow={() => {
                return {
                  onDoubleClick: async () => {
                    // selectRowUpdate(record);
                  },
                  style: {
                    cursor: "pointer",
                  },
                };
              }}
              style={{
                background: "white",
                borderRadius: "8px",
              }}
            />
          </Card>
        </div>
      </Spin>
    </div>
  );
};
export default AuditoriaRuta;
